import React, { Component } from 'react';
import { Select, Button, Row, Col } from 'react-onsenui';
import { LocalizationProvider, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { Card, Label } from 'reactstrap';

const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
const dateFormat = 'YYYY-MM-DD HH:mm:ss';

class OrderTimePicker extends Component {
  constructor(props) {
    super(props);
    this.now = dayjs();
    this.asap = this.now.add(10, 'minutes');
    let initialTime = this.asap;
    let selectValue = 'asap';

    if (props.initialTime) {
      const time = dayjs(props.initialTime, dateFormat);
      if (time.isAfter(this.asap)) {
        initialTime = time;
        selectValue = 'custom';
      }
    }

    this.state = {
      pickupTime: initialTime,
      customTimeOpen: false,
      selectValue, // 'asap', '15', '20', etc. or 'custom'
    };
  }

  componentDidMount() {
    // Ensure pickup time is sent initially
    this.props.onTimeChanged(this.state.pickupTime.utc().format(dateFormat));
  }

  handleOptionSelected = (option) => {
    if (option === 'choose') {
      this.setState({ customTimeOpen: true });
    } else {
      const newTime = option === 'asap' 
        ? this.asap 
        : this.now.add(parseInt(option), 'minutes');
      
      this.setState({
        pickupTime: newTime,
        selectValue: option
      });
      this.props.onTimeChanged(newTime.utc().format(dateFormat));
    }
  };

  handleCustomTimeSelected = (customTime) => {
    this.setState({
      pickupTime: customTime,
      selectValue: 'custom', // Special value for custom times
      customTimeOpen: false
    });
    this.props.onTimeChanged(customTime.utc().format(dateFormat));
  };

  render() {
    const { pickupTime, customTimeOpen, selectValue } = this.state;
    const { closingTime } = this.props;
    const maxTime = closingTime ? dayjs(closingTime, 'HH:mm:ss') : this.now.hour(22).minute(0);

    return (
      <Row className='u-align-items-center'>
        <Col width='100%'><Label>When do you want to pick up?</Label></Col>
        
        <Col width='100%'>
        <Select
            value={selectValue}
            onChange={(event) => this.handleOptionSelected(event.target.value)}
            className='u-mb-1'
          >
            <option value="asap">ASAP</option>
            <option value="15">in 15 minutes</option>
            <option value="20">in 20 minutes</option>
            <option value="25">in 25 minutes</option>
            <option value="30">in 30 minutes</option>
            <option value="choose">Custom time</option>
            {/* Hidden option for custom time selection */}
            <option value="custom" hidden>Custom time</option>
          </Select>
        </Col>
        
        <Col width='100%' className='u-mb-2'>
          Pick up at: <Button className='u-ml-05' onClick={() => this.setState({ customTimeOpen: true })} ripple={true}>
            {pickupTime.format('HH:mm')}
          </Button>
        </Col>

        <Dialog open={customTimeOpen} onClose={() => this.setState({ customTimeOpen: false })}>
          <DialogTitle>
            Select Time
            <IconButton
              aria-label="close"
              onClick={() => this.setState({ customTimeOpen: false })}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopTimePicker
                value={pickupTime}
                onChange={(newValue) => {
                  if (newValue) this.setState({ pickupTime: newValue });
                }}
                minutesStep={5}
                minTime={this.asap}
                maxTime={maxTime}
                ampm={false}
                views={['hours', 'minutes']}
              />
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => this.setState({ customTimeOpen: false })}>Cancel</Button>
              <Button
                onClick={() => {
                  this.handleCustomTimeSelected(this.state.pickupTime);
                }}
              >
                Confirm
              </Button>
          </DialogActions>
        </Dialog>
      </Row>
    );
  }
}

export default OrderTimePicker;